import { render, staticRenderFns } from "./host-common-poster.vue?vue&type=template&id=48374536&scoped=true&"
import script from "./host-common-poster.vue?vue&type=script&lang=js&"
export * from "./host-common-poster.vue?vue&type=script&lang=js&"
import style0 from "./host-common-poster.vue?vue&type=style&index=0&id=48374536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48374536",
  null
  
)

export default component.exports